import { Link } from 'react-router-dom';
import { nr2jOwnerInitials, nr2jOwnerName } from '../../utils/nr2jOwnerScope.js';

/**
 * Commercial propriétaire : avatar initiales + Prénom Nom.
 * Lien vers la fiche collaborateur si `linkable` (Manager / Super Admin), sauf soi-même.
 */
export default function Nr2jOwnerCell({
  user = null,
  owner: ownerProp = null,
  linkable = false,
  viewerId = null,
  compact = false,
}) {
  const owner = user || ownerProp;
  if (!owner) {
    return <span className="text-xs italic text-gray-400">Non attribué</span>;
  }
  const name = nr2jOwnerName(owner);
  const isSelf = viewerId && owner.id === viewerId;
  const label = isSelf ? `${name} (moi)` : name;
  const avatar = (
    <span
      className={`inline-flex shrink-0 items-center justify-center rounded-full bg-indigo-100 font-semibold text-indigo-700 ${
        compact ? 'h-5 w-5 text-[9px]' : 'h-6 w-6 text-[10px]'
      }`}
      aria-hidden="true"
    >
      {nr2jOwnerInitials(owner)}
    </span>
  );
  const text = <span className={`truncate ${compact ? 'text-[11px]' : 'text-xs'}`}>{label}</span>;

  if (linkable && owner.id && !isSelf) {
    return (
      <Link
        to={`/nr2j/mon-equipe/${owner.id}`}
        onClick={(e) => e.stopPropagation()}
        title={owner.email || name}
        className="inline-flex min-w-0 max-w-full items-center gap-1.5 text-gray-700 hover:text-indigo-700 hover:underline"
        data-testid="nr2j-owner-link"
      >
        {avatar}
        {text}
      </Link>
    );
  }
  return (
    <span className="inline-flex min-w-0 max-w-full items-center gap-1.5 text-gray-700" title={owner.email || name}>
      {avatar}
      {text}
    </span>
  );
}
